module.exports = "https://static.wmbcdn.com/uniweb/images/f86a29bfb0b6dcbb26dbbb30e91832a9.svg";